module.exports = __webpack_public_path__ + "img/cloud_d250.b9c2ea78.svg";